module.exports = __webpack_public_path__ + "static/media/patient.f487f95b.svg";